
import './haakon-stub';
import './controllers/app-chrome';
import './components/builder';
import './components/manager';
import * as angular from 'angular';

// Navigation Module
const fallbackServiceFunction = function($q) {
  this.navItemsPromise = $q.defer().resolve([]);
}
try {
  angular.module('MW.IA.Platform.Navigation');
} catch (e) {
  angular.module('MW.IA.Platform.Navigation', [])
          .service('miIaNavigationService', ['$q', fallbackServiceFunction]);
}
// end navigation module

// Header module
try {
  angular.module('MW.IA.Platform.Header');
} catch (e) {
  angular.module('MW.IA.Platform.Header', [])
    .service('miIaHeaderService', ['$q', function($q) {
        this.headerLoadingPromise = $q.defer().resolve();
    }]);
}
// End header module

global.medApp = angular.module('MEDApp', [
    'ngCookies',
    'ngMaterial',
    'mwAppComponents',
    'pascalprecht.translate',
    'MW.Framework.TranslationService',
    'MW.Framework.AppChromeResponsiveController',
    'MW.Framework.NavBarService',
    'MW.IA.Platform.Navigation',
    'MW.IA.Platform.Header',
    'ngRoute',
    'sharable-dashboard.builder',
    'sharable-dashboard.manager'
])
.directive('forceSelectFocus', function() {
  return {
    restrict: 'A',
    require: ['^^mdSelect', '^ngModel'],
    link: function(scope, element, controller) {
      scope.$watch(function () {
        let foundElement = element;
        while (!foundElement.hasClass('md-select-menu-container')) {
          foundElement = foundElement.parent();
        }
        return foundElement.hasClass('md-active');
      }, function (newVal) {
        if (newVal) {
            element.focus();
        }
      })
    }
  }
});

import './providers-config';